import styled from 'styled-components';
import { Col } from 'antd';

export const Container = styled(Col)`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
`;
